import React, { useState, useEffect } from "react";

const API_BASE_URL = `${process.env.REACT_APP_API_URL.replace(/\/$/, '')}/api`;

const ModalAddScope = ({ isOpen, onClose, onSave, isEmbedded = false }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [workScopes, setWorkScopes] = useState([]);
  const [selectedScopes, setSelectedScopes] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {      
      fetchWorkScopes();
    }
  }, [isOpen]);

  const fetchWorkScopes = async () => {
    const token = localStorage.getItem("access_token");
    try {
      const response = await fetch(`${API_BASE_URL}/workscopes/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Błąd: ${response.status}`);
      }

      const data = await response.json();
      console.log("workscopes", data);
      setWorkScopes(data);
    } catch (error) {
      console.error("Błąd podczas pobierania zakresów pracy:", error.message);
      alert("Nie udało się pobrać zakresów pracy.");
    }
  };

  const handleScopeSelection = (scopeId) => {
    setSelectedScopes((prev) =>
      prev.includes(scopeId)
        ? prev.filter((id) => id !== scopeId)
        : [...prev, scopeId]
    );
  };

  const handleSave = async () => {
    if (!name) {
      alert("Name is required");
      return;
    }
    
    setIsSubmitting(true);
    const token = localStorage.getItem('access_token');
    console.log("Dane wysyłane do API:", { name, description, workscope: selectedScopes });
    
    try {
      const response = await fetch(`${API_BASE_URL}/scopeofworks/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, description, workscope: selectedScopes }),
      });

      if (!response.ok) {
        throw new Error(`Błąd: ${response.status}`);
      }

      const data = await response.json();
      console.log("Zapisany zakres :", data); // Sprawdzenie danych w konsoli

      // Reset form
      resetForm();
      
      onSave(); // Wywołanie po udanym zapisie (np. odświeżenie zakresów)
      onClose(); // Zamknięcie modala
    } catch (error) {
      console.error("Błąd podczas zapisywania zakresu pracy:", error.message);
      alert("Nie udało się zapisać zakresu pracy.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setName("");
    setDescription("");
    setSelectedScopes([]);
  };

  const handleCancel = () => {
    resetForm();
    onClose();
  };

  if (!isOpen) return null;

  // Form content to be reused in both embedded and modal views
  const formContent = (
    <>
      <div>
        <label className="block text-sm font-medium text-graphite-700">Scope of work</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Name"
          className="w-full border rounded px-3 py-2 mb-4"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-graphite-700">Description</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Description"
          className="w-full border rounded px-3 py-2 mb-4"
          rows={3}
        />
      </div>
      <div className="mb-4">
        <label className="block text-sm font-medium text-graphite-700">Assign this scope to authorization level</label>
        <div className="mt-2">
          {workScopes.map((scope) => (
            <div key={scope.id} className="flex items-center">
              <input
                type="checkbox"
                id={`scope-${scope.id}`}
                checked={selectedScopes.includes(scope.id)}
                onChange={() => handleScopeSelection(scope.id)}
                className="mr-2"
              />
              <label htmlFor={`scope-${scope.id}`} className="text-sm text-graphite-700">{scope.name}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end space-x-2">
        <button
          onClick={handleCancel}
          className="px-4 py-2  border border-steel-300 text-graphite-700 font-medium rounded-full hover:bg-steel-100 flex items-center text-sm whitespace-nowrap"
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2  border border-brand-500 bg-brand-500 font-medium text-white rounded-full hover:bg-brand-600 flex items-center text-sm whitespace-nowrap"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Saving..." : "Save"}
        </button>
      </div>
    </>
  );

  // When embedded in the toggle menu
  if (isEmbedded) {
    return (
      <div>
        <h3 className="text-lg font-semibold mb-4">Add Scope of Work</h3>
        {formContent}
      </div>
    );
  }

  // When used as a standalone modal
  return (
    <div className="fixed inset-0 bg-graphite-950/50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-md w-96">
        <h2 className="text-xl font-semibold mb-4">Add Scope of Work</h2>
        {formContent}
      </div>
    </div>
  );
};

export default ModalAddScope;